import { useTranslation } from "react-i18next";

function EducationalConsultantRequests() {
  const { t } = useTranslation();
  return (
    <div className="flex w-[409px] h-[247px] flex-col justify-center items-center gap-5 ">
      <img
        alt=""
        className="h-[113px] w-[113px]"
        src="/assets/images/icon.png"
      />
      <div className="flex-col justify-start items-center gap-3 flex">
        <div className="text-center text-zinc-900 text-base font-arMedium">
          {t("requests.component.noRequestsNow")}
        </div>
        <button className="p-2 bg-mint-500 text-center text-white text-lg font-arMedium rounded-xl">
          {t("requests.component.submitNewRequest")}
        </button>
        <div className="w-[409px] text-center"></div>
      </div>
    </div>
  );
}

export default EducationalConsultantRequests;
